/**

 Offcanvas customization

 Minor JavaScript tweaks for working with the off canvas

 */

const $         = require( 'jQuery' );
const { Foundation } = window;

var ToggleMenu = function( el ) {

    this.$el = $(el);
    this.menuCheckbox   = this.$el.find('.itbl-c-nav__burger');
    this.body           = $(document).find( 'body' );
    this.offCanvasMenu  = this.$el.find( '.itbl-c-offcanvas' );
    this.transFormClass = 'transform-active';
    this.$submenu       = this.$el.find( '.itbl-c-masthead__sub-menu-group' );
    this.$mobileToggle  = this.$el.find( '.js-mobile-toggle' );
    this.$nonLink       = this.body.find( '.itbl-non-link' );
    this.$dataMenuToggle = this.$el.find('[data-menu-toggle]');

    this.activeSubmenu = null;
    this.activeSubmenuEl = null;

    this.init();

};

ToggleMenu.prototype.init = function(){

    var that = this;

    //events
    $(window)
        .on( 'changed.zf.mediaquery', this.closeForMedium.bind( this ) );

    this.menuCheckbox.on( 'click', function(event){

        event.preventDefault();

        that.event__toggleEverything();


    } );


    this.$dataMenuToggle.on( 'click', this.handleOpenSubmenu.bind(this) );


    this.$mobileToggle.on( 'click', this.event__toggleMobileMenu.bind(this) );

    $(document).not(this.$dataMenuToggle).on(
      'mouseup',
      this.handleClickOutsideOfToggle.bind(this)
    );

};

ToggleMenu.prototype.handleClickOutsideOfToggle = function (e) {
    const toggleId = this.$dataMenuToggle.data('menu-toggle')
    const $clickedTarget = $(e.target)
    const parentId = $clickedTarget.parent().data('menu-toggle')
    const id = $clickedTarget.attr('id')

    const isToggleItself = id === toggleId
    const isSpanInsideToggle = (
      $clickedTarget.is('span') &&
      parentId === toggleId
    )

    if (!isToggleItself && !isSpanInsideToggle) {
        this.handleCloseOnDoc(e)
    }
}

ToggleMenu.prototype.handleCloseOnDoc = function(event){

    const $target = $(event.target);

    if( !this.activeSubmenuEl && !this.activeSubmenu ){
        return;
    }
    try{
        if( this.activeSubmenuEl.is(':visible') &&
            !this.activeSubmenuEl.is( $target ) &&
            this.activeSubmenuEl.find( $target ).length === 0 &&
            !this.$dataMenuToggle.is( $target )
        ){
            this.clearMenu();

            $(document).off('mouseup', this.handleCloseOnDoc.bind(this) );
        }
    }catch(e){
        console.log(e);
    }


};

ToggleMenu.prototype.clearMenu = function(){

    this.$submenu.removeClass( 'is-open' );
    this.activeSubmenu = null;
    this.activeSubmenuEl = null;
};

ToggleMenu.prototype.handleOpenSubmenu = function(event){
    event.preventDefault();
    event.stopPropagation();

    //get the data target
    const $target = $(event.currentTarget);

    //get the ID
    const submenuId = $target.data('menu-toggle');
    const submenuEl = this.$submenu.filter( function(){
        return $(this).attr('id') === submenuId;
    } );

    if( submenuEl && this.activeSubmenu === submenuId ){

        this.clearMenu();

    }else{

        this.$submenu.removeClass( 'is-open' );
        submenuEl.addClass( 'is-open' );

        this.activeSubmenu = submenuId;
        this.activeSubmenuEl = submenuEl;
    }

};


ToggleMenu.prototype.event__toggleEverything = function(){

    $(this.menuCheckbox).toggleClass( this.transFormClass );
    this.$el.toggleClass( this.transFormClass );
    this.body.toggleClass( 'no-scroll' );
    $(this.offCanvasMenu).toggleClass( this.transFormClass );

};


ToggleMenu.prototype.closeForMedium = function( event, newSize, oldSize ){

    if(  Foundation.MediaQuery.atLeast('small')  && $(this.$el).hasClass( this.transFormClass ) ){

       this.event__toggleEverything();

       //this closes all submenus if they are open and resizes from large to medium
    }else if( oldSize === 'large' && newSize === 'medium' ){

        this.clearMenu();
    }
};

ToggleMenu.prototype.event__toggleMobileMenu = function(event){

    const target    = $( event.currentTarget);
    const drawer    = target.next( '.itbl-mobile-dropdown-menu' );
    const chevron   = target.find( '> .fa-chevron-down' );

    chevron.toggleClass( 'transform-active' );
    $(drawer).slideToggle('fast');

};


$(document).ready(function(){
    $('.itbl-c-nav').each(function(){
        new ToggleMenu(this);

    });
});


